"use strict";

export default function ({ store, redirect }) {
  if (!store.state.auth) return redirect("/login");
  if (!store.state.auth.user) return redirect("/login");
}
